import React, { Component } from 'react';
import Wrapper from './Wrapper';
import Toastr from '../stateless/common/Toastr/Toastr';

const NotifyWrapper = (AnyComponent , AxiosInstance) => {
    return class extends Component {
        
        state = {
            isSuccessMessage : false,
            isFailureMessage : false
        }

        responseIntercept = null;

        componentDidMount(){
            this.responseIntercept =AxiosInstance.interceptors.response.use(response => {
                this.setState({isSuccessMessage:true});
                return response;
            }, error => {
                this.setState({isFailureMessage:true});
                return error;
            });
        }

        closeHandler = () => {
            this.setState({
                isSuccessMessage : false,
                isFailureMessage : false
            })
        }

        componentWillUnmount = () => {
            AxiosInstance.interceptors.response.eject(this.responseIntercept);
        }

        render(){
            return (
            <Wrapper>
                {this.state.isSuccessMessage ? 
                <Toastr open={this.state.isSuccessMessage}
                        severity="success"
                        color="info"
                        content="Saved Successfully."
                        closeHandler={this.closeHandler}/>
                : null}
                {this.state.isFailureMessage ? 
                <Toastr open={this.state.isFailureMessage} 
                        severity="error" color="error" 
                        content="Error Occured."
                        closeHandler={this.closeHandler}/>
                : null}
                <AnyComponent {...this.props}/>
            </Wrapper>
            );
        }
    }
}

export default NotifyWrapper;